import React from 'react';
import { EyeIcon, LockIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Card, SectionTitle } from '../components/ui/Card';
import { Switch } from '../components/ui/Switch';
import { metricGroupsForSport, sports, standaloneMetrics } from '../data/sportMetrics';
import { formatMetricGroup } from '../utils/sportFields';
import { useLocale } from '../contexts/LocaleContext';
import { useMetrics } from '../contexts/MetricsContext';
import { formatMetric } from '../utils/units';
export function PublicMetrics() {
  const {
    t,
    tl,
    locale
  } = useLocale();
  const metrics = useMetrics();
  return <div className="px-2 pb-2" data-id="element-3583" data-mp="2ursxjg3wkikt">
      <PageHeader title={t('metrics.public.title')} subtitle={t('metrics.public.subtitle')} showBack data-id="element-3584" data-mp="2uux5mokhnygr" />

      <Card className="p-2" data-id="element-3585" data-mp="1jegp0rx77bsb">
        <p className="flex items-start gap-2 text-[12px] leading-snug text-muted" data-id="element-3586" data-mp="1jeqgyl1szt0n">
          <LockIcon size={14} className="mt-[1px] shrink-0" aria-hidden="true" data-id="element-3587" data-mp="1edsv9yhl4gue" />
          {t('metrics.public.note')}
        </p>
      </Card>

      {sports.map(sport => <section key={sport} className="mt-3" data-id="element-3588" data-mp="m4ixmbw1a2dz">
          <SectionTitle data-id="element-3589" data-mp="m3hc1dhe5xi0">{t(`category.${sport}`)}</SectionTitle>
          <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-3590" data-mp="85145j7sm0ya">
            {[...standaloneMetrics(sport).map(metric => ({
          id: metric.id,
          label: metric.label,
          display: metric.value > 0 ? formatMetric(metric.kind, metric.value, metrics.unitSystem) : '—'
        })),
        // Grouped records (Boxing cartel) — one row, one public choice.
        ...metricGroupsForSport(sport).map(group => ({
          id: group.id,
          label: group.label,
          display: group.members.some(member => member.value > 0) ? formatMetricGroup(group.members.map(member => member.id), Object.fromEntries(group.members.map(member => [member.id, member.value])), locale) : '—'
        }))].map(metric => {
          const isPublic = metrics.isPublic(metric.id);
          return <li key={metric.id} className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-3591" data-mp="2irl5cy8td5c6">
                  <span className="min-w-0 flex-1" data-id="element-3592" data-mp="3beo2blxud80b">
                    <span className="block text-[13px] font-medium text-deep" data-id="element-3593" data-mp="3bfz3ddzwk1nq">
                      {tl(metric.label)}
                    </span>
                    <span className="bee-num mt-[2px] block text-[11.5px] text-muted" data-id="element-3594" data-mp="31hjcnc4seuer">
                      {metric.display}
                    </span>
                  </span>
                  <span className={`flex shrink-0 items-center gap-1 text-[10.5px] font-medium ${isPublic ? 'text-gold-deep' : 'text-muted'}`} data-id="element-3595" data-mp="1q1uq2lvg3xeh">
                    {isPublic ? <EyeIcon size={13} data-id="element-3596" data-mp="ajyi2k6ulxf1" /> : <LockIcon size={13} data-id="element-3597" data-mp="ajg9qp6wvsqr" />}
                    {t(isPublic ? 'metrics.publicOn' : 'metrics.publicOff')}
                  </span>
                  <Switch checked={isPublic} onChange={() => metrics.togglePublic(metric.id)} label={`${t('metrics.public.title')} — ${tl(metric.label)}`} data-id="element-3598" data-mp="k8gd0ksg5aar" />
                </li>;
        })}
          </ul>
        </section>)}
    </div>;
}